export const UPDATE_ARTICLES = 'UPDATE_ARTICLES'
export const UPDATE_ARTICLE = 'UPDATE_ARTICLE'
export const UPDATE_PREVIEW_ARTICLES = 'UPDATE_PREVIEW_ARTICLES'
export const UPDATE_LATEST_ARTICLES = 'UPDATE_LATEST_ARTICLES'
export const UPDATE_LOADING_ATTACHMENTS = 'UPDATE_LOADING_ATTACHMENTS'
export const UPDATE_ATTACHMENTS = 'UPDATE_ATTACHMENTS'
export const UPDATE_ATTACHMENT_PAGINATION = 'UPDATE_ATTACHMENT_PAGINATION'
export const UPDATE_ARTICLE_PAGINATION = 'UPDATE_ARTICLE_PAGINATION'
export const UPDATE_NEW_ATTACHMENT_FILE_LIST = 'UPDATE_NEW_ATTACHMENT_FILE_LIST'
export const UPDATE_ARTICLE_DESCRIPTION = 'UPDATE_ARTICLE_DESCRIPTION'
export const UPDATE_PREVIEW_CATEGORY = 'UPDATE_PREVIEW_CATEGORY'
export const UPDATE_SUB_CATEGORY_FILTER = 'UPDATE_SUB_CATEGORY_FILTER'
export const UPDATE_EXPORT_DATA = 'UPDATE_EXPORT_DATA'
export const UPDATE_ARTICLE_SEARCH_TERM = 'UPDATE_ARTICLE_SEARCH_TERM'
export const UPDATE_TEMPLATES = 'UPDATE_TEMPLATES'
export const UPDATE_ARTICLE_AUTHORS = 'UPDATE_ARTICLE_AUTHORS'
